import React, { useState, useEffect, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  IconButton,
  Collapse
} from '@material-ui/core';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { useSelector } from 'react-redux';
import _ from 'lodash';

import withAlert from '../../../../hoc/withAlert';
import {
  getEventeatingByDateAndEatingSelector,
  addEventeatingMeal,
  deleteEventeatingMeal
} from '../../../../store/eventeating';
import { getMealSelector } from '../../../../store/meal';
import {
  getTicketMealReportByDateSelector,
  getTicketMealReportCouponsByDateSelector
} from '../../../../store/ticket';

const useStyles = makeStyles(theme => ({
  nestedHead: {
    paddingLeft: theme.spacing(4)
  },
  nested: {
    paddingLeft: theme.spacing(6)
  },
  weekend: {
    backgroundColor: '#e0f2f1'
  },
  listItemText: {
    fontSize: 13
  },
  listItemNumber: {
    fontSize: 13,
    fontWeight: 600
  }
}));

const Eating = props => {
  const {
    name,
    meetingId,
    date,
    eating,
    onCheckedOne,
    setSnackMessage,
    setSnackType,
    setOpenSnack
  } = props;

  const classes = useStyles();

  const mealData = useSelector(getMealSelector);
  const eventeatings = useSelector(
    getEventeatingByDateAndEatingSelector(meetingId, date, eating.id)
  );
  const report = useSelector(
    getTicketMealReportByDateSelector(date, eating.id)
  );
  const coupons = useSelector(getTicketMealReportCouponsByDateSelector(date));

  const [dishes, setDishes] = useState([]);

  useEffect(() => {
    if (eventeatings) {
      if (eventeatings.meals && eventeatings.meals.length > 0) {
        const chosenDishes = mealData.filter(m =>
          eventeatings.meals.includes(m.id)
        );
        setDishes(chosenDishes);
        const newOpen = chosenDishes.reduce(function(res, d) {
          res[d.id] = false;
          return res;
        }, {});

        setOpen(newOpen);
      }
    }
  }, [eventeatings]);

  // Состояние открыт закырт
  const [open, setOpen] = useState({});
  // console.log('open',open);

  //  Обработчик свертывания развертывания
  const handleClick = id => {
    setOpen({ ...open, [id]: !open[id] });
  };

  const customerTypesLabels = {
    team: '😻',
    // 5: 'Участники',
    special: '🔥'
  };

  const customerTypesId = {
    team: 2,
    // 5: 'Участники',
    special: 6
  };

  const getCustomerTypeLabel = id => {
    const key = Object.keys(customerTypesId).find(
      key => customerTypesId[key] === id
    );
    if (key) {
      return customerTypesLabels[key] + ' ';
    }
    return ' ';
  };

  const getCouponsCountLabel = (report, dishId, customerType) => {
    if (!(dishId in report)) return '';
    return customerTypesId[customerType] in report[dishId]
      ? `, ${customerTypesLabels[customerType]}: ${
          report[dishId][customerTypesId[customerType]]
        }`
      : '';
  };

  return (
    <React.Fragment>
      <Typography variant="h5" style={{ fontSize: 14 }}>
        {name}
      </Typography>
      <List dense={true}>
        {dishes &&
          dishes
            .filter(d => d.isCombo !== 1)
            .map(d => (
              <React.Fragment key={d.id}>
                <ListItem button onClick={e => handleClick(d.id)}>
                  {open[d.id] ? <ExpandLess /> : <ExpandMore />}
                  <ListItemText
                    classes={{ primary: classes.listItemText }}
                    classes={{ secondary: classes.listItemNumber }}
                    // primary={`${d.id}. ${d.name} —  ${report && report[d.id] ? report[d.id]: 0 }`}
                    primary={`${d.id}. ${d.name} `}
                    secondary={`Всего: ${
                      report && report[d.id] && report[d.id]['total']
                        ? report[d.id]['total']
                        : 0
                    }${report &&
                      getCouponsCountLabel(report, d.id, 'team')}${report &&
                      getCouponsCountLabel(report, d.id, 'special')}`}
                  />
                </ListItem>
                <Collapse
                  in={open[d.id]}
                  timeout="auto"
                  unmountOnExit
                  className={classes.nested}>
                  <List dense={true}>
                    {coupons &&
                      coupons.length > 0 &&
                      coupons
                        .filter(
                          c => c.meal_id === d.id && c.eating_id === eating.id
                        )
                        .map(c => (
                          <ListItem key={`${c.id}_${c.meal_id}_${c.parentId}`}>
                            {' '}
                            <ListItemText
                              primary={`${getCustomerTypeLabel(
                                c.customertype_id
                              )}${c.name} ${c.surname} — ${c.amount}  — ${
                                c.isCombo ? c.parentName : c.mealName
                              }`}
                            />
                          </ListItem>
                        ))}
                  </List>
                </Collapse>
              </React.Fragment>
            ))}
      </List>
    </React.Fragment>
  );
};

export default withAlert(Eating);
